exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rounded-circle{border-radius:50%}.translation .dropdown-toggle{margin-top:2px}.profile-menu>a{line-height:0!important;padding:0!important;margin:13px;border-radius:50%}.profile-menu.open .profile{border-color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/app/shared/ui/topbar/topbar.css
// module id = 498
// module chunks = 0